import { ButtonLink, Heading, Inline, Stack, Text } from 'braid-design-system';

export const SearchLandingPageBanner = ({
  title,
  description,
  buttonText,
  href,
}: {
  title: string;
  description: string;
  buttonText: string;
  href: string;
}) => (
  <Stack space="large">
    <Heading level="2">{title}</Heading>
    <Text>{description}</Text>
    <Inline space="none">
      <ButtonLink href={href} tone="formAccent" variant="solid">
        {buttonText}
      </ButtonLink>
    </Inline>
  </Stack>
);
